import { useEffect, useState } from "react";
import useViewport from "../../hooks/useViewport";
import "./style.css";

import icon_deviantart from '../../assets/img/social-icon_deviantart.webp'
import icon_yt from '../../assets/img/social-icon_ytb.webp'
import icon_email from '../../assets/img/social-icon_email-yellow.png'
import icon_facebook from '../../assets/img/social-icon_fb.webp'
import icon_insta from '../../assets/img/social-icon_insta.webp'
import icon_threads from '../../assets/img/social-icon_threads.webp'

import loader1 from "../../assets/img/loader-bg_1.webp";
import loader2 from "../../assets/img/loader-bg_2.webp";
import loader3 from "../../assets/img/loader-bg_3.webp";
import loader4 from "../../assets/img/loader-bg_4.webp";
import loader5 from "../../assets/img/loader-bg_5.webp";
import loader6 from "../../assets/img/loader-bg_6.webp";

const loaders = [loader1, loader2, loader3, loader4, loader5, loader6];
const num = Math.floor(Math.random() * 6);

function Loader() {
    const { isMobile } = useViewport();
    const [visible, setVisible] = useState(true);
    const [isFading, setIsFading] = useState(false);

    const path = !isMobile
        ? `${process.env.REACT_APP_API_URL}/files/images/loader-bg_${num + 1}.webp`
        : loaders[num];

    useEffect(() => {
        const img = new Image();
        img.src = path;

        let minTimer;
        let removeTimer;

        // ⏳ MAX 3 secondes depuis le début
        const maxTimer = setTimeout(() => {
            startFadeOut();
        }, 3000);

        img.onload = () => {
            // ⏳ 1 seconde APRES chargement image
            minTimer = setTimeout(() => {
                startFadeOut();
            }, 1000);
        };

        function startFadeOut() {
            clearTimeout(maxTimer);
            clearTimeout(minTimer);

            setIsFading(true);

            // attendre la transition CSS (1s)
            removeTimer = setTimeout(() => {
                setVisible(false);
            }, 1000);
        }

        return () => {
            clearTimeout(maxTimer);
            clearTimeout(minTimer);
            clearTimeout(removeTimer);
        };
    }, [path]);

    if (!visible) return null;

    return (
        <div className={`loader ${isFading ? "fade-out" : "fade-in"}`}>
            <div className="container">
                <p className="title">VanRah</p>
                <p className="subtitle">Original Manga Artist</p>
            </div>

            {/* 👉 image statique */}
            <i
                className="illustration fade-in"
                style={{ backgroundImage: `url('${path}')` }}
            ></i>

            {/* 🔽 Tout le reste inchangé */}
            <div className="socials_mob">
                <i className="logo_vanrah"></i>

                <ul>
                    <li><a href="https://www.facebook.com/VanRah.Sama/" target="blank"><img src={icon_facebook} alt="" /></a></li>
                    <li><a href="https://www.instagram.com/vanrah.sama/?next=%2F" target="blank"><img src={icon_insta} alt="" /></a></li>
                    <li><a href="https://www.youtube.com/@VanRah-Sama" target="blank"><img src={icon_yt} alt="" /></a></li>
                    <li><a href="mailto:vanrah-tegamiden@outlook.com"><img src={icon_email} alt="" /></a></li>
                    <li><a href="https://www.deviantart.com/vanrah" target="blank"><img src={icon_deviantart} alt="" /></a></li>
                    <li><a href="https://www.threads.com/@vanrah.sama" target="blank"><img src={icon_threads} alt="" /></a></li>
                </ul>

                <p className="copyright">
                    Copyright © 2026 VanRah. All rights reserved. <br />
                    Design by : VanRah <br />
                    Developed by : C. Beaudet
                </p>
            </div>

            <div className="socials_desktop">
                <ul>
                    <li><a href="https://www.facebook.com/VanRah.Sama/" target="blank"><img src={icon_facebook} alt="" /></a></li>
                    <li><a href="https://www.instagram.com/vanrah.sama/?next=%2F" target="blank"><img src={icon_insta} alt="" /></a></li>
                    <li><a href="https://www.youtube.com/@VanRah-Sama" target="blank"><img src={icon_yt} alt="" /></a></li>
                </ul>

                <div className="copyright">
                    <i className="logo_vanrah"></i>

                    <p>
                        Copyright © 2026 VanRah. All rights reserved. <br />
                        Design by : VanRah <br />
                        Developed by : C. Beaudet
                    </p>
                </div>

                <ul className="reverse">
                    <li><a href="mailto:vanrah-tegamiden@outlook.com"><img src={icon_email} alt="" /></a></li>
                    <li><a href="https://www.deviantart.com/vanrah" target="blank"><img src={icon_deviantart} alt="" /></a></li>
                    <li><a href="https://www.threads.com/@vanrah.sama" target="blank"><img src={icon_threads} alt="" /></a></li>
                </ul>
            </div>
        </div>
    );
}

export default Loader;